export default __webpack_public_path__ + "static/media/slide2.dedc3f65.png";